/*!
 * c-disclosure — adds 200ms slide animation to <details class="accordian">.
 * Intercepts clicks on <summary>, animates the next sibling answer's height,
 * and toggles the [open] attribute after animation completes.
 * Also enforces single-open behavior across siblings sharing a name="" attribute.
 */
(function () {
  var DURATION = 200;

  function animate(answer, fromHeight, toHeight, after) {
    answer.style.height = fromHeight + 'px';
    answer.style.overflow = 'hidden';
    answer.style.transition = 'none';
    void answer.offsetHeight; // force reflow
    answer.style.transition = 'height ' + DURATION + 'ms ease';
    requestAnimationFrame(function () {
      answer.style.height = toHeight + 'px';
    });
    setTimeout(function () {
      answer.style.height = '';
      answer.style.overflow = '';
      answer.style.transition = '';
      if (after) after();
    }, DURATION);
  }

  function getAnswer(details) {
    return details.querySelector('.shopify_explorer_faq__answer')
      || details.querySelector(':scope > :not(summary)');
  }

  function close(details) {
    var answer = getAnswer(details);
    if (!answer) { details.open = false; return; }
    var current = answer.scrollHeight;
    animate(answer, current, 0, function () { details.open = false; });
  }

  function open(details) {
    var answer = getAnswer(details);
    if (!answer) { details.open = true; return; }
    details.open = true;
    var target = answer.scrollHeight;
    animate(answer, 0, target);
  }

  document.addEventListener('click', function (e) {
    var summary = e.target.closest && e.target.closest('summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || !details.classList.contains('accordian')) return;
    e.preventDefault();

    if (details.open) {
      close(details);
      return;
    }

    // Single-open: close siblings sharing the same name attribute
    var name = details.getAttribute('name');
    if (name) {
      document.querySelectorAll('details.accordian[name="' + name + '"][open]').forEach(function (other) {
        if (other !== details) close(other);
      });
    }
    open(details);
  });
})();
